import { render, staticRenderFns } from "./checkInfo.vue?vue&type=template&id=1d95c924&scoped=true&"
import script from "./checkInfo.vue?vue&type=script&lang=js&"
export * from "./checkInfo.vue?vue&type=script&lang=js&"
import style0 from "./checkInfo.vue?vue&type=style&index=0&id=1d95c924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95c924",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d95c924')) {
      api.createRecord('1d95c924', component.options)
    } else {
      api.reload('1d95c924', component.options)
    }
    module.hot.accept("./checkInfo.vue?vue&type=template&id=1d95c924&scoped=true&", function () {
      api.rerender('1d95c924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/components/checkInfo.vue"
export default component.exports